import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./Styles.css";
import kcIcon from "../../assets/icons/kingschat.png";

import { auth, googleProvider } from "../../firebase";
import { signInWithPopup, signInWithRedirect } from "firebase/auth";

const API_URL = process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || 'https://ceindiazone2.in');

const SignUp = () => {
  const navigate = useNavigate();
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // UserRegistrationRequest: email, phone, macAddress, name, deviceModel, platoform. No password!
  // I will add password state but not send it if the backend doesn't take it? Or maybe the user didn't show the full class.
  // Using the fields I know:
  // Helper to generate random MAC address for testing
  const generateRandomMac = () => {
    return "XX:XX:XX:XX:XX:XX".replace(/X/g, function () {
      return "0123456789ABCDEF".charAt(Math.floor(Math.random() * 16));
    });
  };

  const [macAddress] = useState(generateRandomMac()); // Random MAC for each session
  const [deviceModel] = useState(navigator.userAgent ? navigator.userAgent.substring(0, 250) : "Unknown Device");
  const [platform] = useState("Web");

  // Google Login Handler
  const handleGoogleLogin = async () => {
    try {


      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      const payload = {
        email: user.email,
        name: user.displayName || "Google User",
        googleId: user.uid,
        photoUrl: user.photoURL,
        deviceModel: navigator.userAgent,
        platform: "Web",
        macAddress: macAddress
      };
      
      const response = await fetch(`${API_URL}/api/auth/google-login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.message || `Backend returned status ${response.status}`);
      }
      
      const data = await response.json();
      if (data && (data.id || data.currentSessionToken)) {
        localStorage.setItem("user", JSON.stringify(data));
        if (data.role === 'ADMIN') {
          localStorage.setItem("adminUser", JSON.stringify(data));
          alert(`Google Login Success! Welcome Admin ${data.name}`);
          window.location.href = "/admin/dashboard";
        } else {
          alert(`Google Login Success! Welcome ${data.name}`);
          window.location.href = "/";
        }
      } else {
        throw new Error("Invalid response structure from backend");
      }
    } catch (error) {
      console.error("Google login error:", error);
      // Fallback to redirect if popup fails or is blocked on mobile
      try {
        await signInWithRedirect(auth, googleProvider);
      } catch (redirectErr) {
        alert("Google login failed: " + redirectErr.message);
      }
    }
  };

  const handleKingsChatLogin = () => {
    sessionStorage.setItem("login_provider", "kingschat");
    const clientId = process.env.REACT_APP_KINGSCHAT_CLIENT_ID || "409892e9-24a8-45b9-a23c-e2cb22f377d8";
    const redirectUri = "https://ceindiazone2.in";
    const authUrl = `https://accounts.kingschat.online/log-in?clientId=${clientId}&redirectUri=${encodeURIComponent(redirectUri)}`;
    window.location.href = authUrl;
  };


  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      let submitEmail = null;
      let submitPhone = null;

      if (emailOrPhone) {
        if (emailOrPhone.includes('@')) {
          submitEmail = emailOrPhone;
        } else {
          submitPhone = emailOrPhone;
        }
      }

      const payload = {
        email: submitEmail,
        phone: submitPhone,
        macAddress: macAddress,
        name: title ? `${title} ${name}` : name, // Concatenate title with full name for the backend payload
        password: password,
        deviceModel: deviceModel,
        platoform: platform // Typo intentional per backend
      };

      const response = await axios.post(`${API_URL}/api/auth/register`, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      localStorage.setItem("user", JSON.stringify(response.data)); // Save user session
      
      if (response.data.role === 'ADMIN') {
        localStorage.setItem("adminUser", JSON.stringify(response.data));
        alert(`Registered successfully: Admin ${response.data.name}`);
        window.location.href = "/admin/dashboard";
      } else {
        alert(`Registered successfully: ${response.data.name}`);
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Registration failed", error);
      const errorMsg = error.response?.data?.message || error.response?.data || error.message || "";
      if (
        error.response?.status === 409 || 
        String(errorMsg).toLowerCase().includes("exist") || 
        String(errorMsg).toLowerCase().includes("already")
      ) {
        alert("Account exist try to sign in");
      } else {
        alert(typeof errorMsg === 'string' && errorMsg.length < 100 ? `Registration failed: ${errorMsg}` : "Registration failed!");
      }
    }
  };

  return (
    <div className="signup-container">
      <button className="back-btn" onClick={() => navigate('/')}>
        ←
      </button>

      {/* Left Side (Image + Text) */}
      <div className="signup-left">
        <div className="signup-left-content">
          <h1>Create your Account</h1>
          <p>Share your artwork and Get projects!</p>
        </div>
      </div>

      {/* Right Side (Form) */}
      <div className="signup-right">
        <h2>Sign Up</h2>
        <p style={{ fontSize: '0.85rem', color: '#ffcc00', marginBottom: '15px', textAlign: 'center' }}>
          Phone number login coming soon. For now, sign in with your email address.
        </p>
        <form onSubmit={handleRegister}>
          <div className="form-group">
            <select
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="title-dropdown"
              required
            >
              <option value="" disabled>Select Title</option>
              <option value="Pastor">Pastor</option>
              <option value="Deaconess">Deaconess</option>
              <option value="Brother">Brother</option>
              <option value="Sister">Sister</option>
            </select>
          </div>
          <div className="form-group">
            <input type="text" placeholder="Full name" onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="form-group">
            <input type="text" placeholder="Email or Phone number" onChange={(e) => setEmailOrPhone(e.target.value)} required />
          </div>
          <div className="form-group">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="has-eye-icon"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
          <div className="form-check">
            <input type="checkbox" />
            <label>Accept Terms & Conditions</label>
          </div>
          <button type="submit" className="join-btn">Join us →</button>
        </form>

        <br />
        <button 
          type="button" 
          className="kingschat-btn" 
          onClick={handleKingsChatLogin}
          style={{
            width: '100%',
            padding: '12px',
            marginBottom: '12px',
            borderRadius: '8px',
            border: 'none',
            background: 'linear-gradient(135deg, #0052cc 0%, #0066ff 100%)',
            color: 'white',
            fontWeight: '700',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            boxShadow: '0 4px 14px rgba(0, 102, 255, 0.35)',
            transition: 'all 0.3s ease'
          }}
        >
          <img src={kcIcon} alt="KingsChat" width="22" height="22" style={{ objectFit: 'contain' }} />
          Sign up through KingsChat
        </button>
        <button type="button" className="google-btn" onClick={handleGoogleLogin}>
          Sign up with Google
        </button>
        <p className="or-text">Already have an account?<span> <Link to="/signin" className="toggle-btn">
          Sign In
        </Link></span></p>
      </div>

    </div>
  );
};

export default SignUp;
